import { Route, Routes } from 'react-router-dom';
import CreateProgram from '../components/create-program/Create-program';
import UpdateData from '../components/updateData/updateData';

export const RoutesUpdateData = () => {
  return (
    <>
      <Routes>
        <Route path='/' element={<UpdateData />} />
        <Route
          path=':programId/:year/:month'
          element={<CreateProgram isUpdated={false} />}
        />
      </Routes>
    </>
  );
};
